module.exports = __webpack_public_path__ + "static/media/SLIGHTLY_RIGHT.177fb2dc.svg";